import React from 'react'

const Configuration = () => {
  return (
    <div>
      Config
    </div>
  )
}

export default Configuration
